<template>
  <v-select
    :value="value"
    :items="filterOptions"
    item-text="text"
    item-value="value"
    dense
    outlined
    hide-details
    style="width: 170px;"
    class="insect-filter-select"
    @change="$emit('input', $event)"
  >
    <!-- カスタムアイテム表示 -->
    <template #item="{ item, on, attrs }">
      <!-- グループヘッダー（選択可能） -->
      <v-list-item
        v-if="item.isGroup"
        v-bind="attrs"
        v-on="on"
        class="group-header"
      >
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ item.text }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <!-- 通常アイテム（インデント付き） -->
      <v-list-item
        v-else
        v-bind="attrs"
        v-on="on"
        :class="{ 'pl-6': item.indent }"
      >
        <v-list-item-content>
          <v-list-item-title>{{ item.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>

    <!-- 選択された値の表示 -->
    <template #selection="{ item }">
      <span class="selection-text">{{ item.text }}</span>
    </template>
  </v-select>
</template>

<i18n lang="yaml">
ja:
  all: 全て
  indoor: 内部発生
  outdoor: 外部侵入
  other: その他

en:
  all: All
  indoor: Indoor
  outdoor: Outdoor
  other: Other
</i18n>

<script>
import { flyingInsectTypeMap } from '@/libs/insectTypes';

export default {
  name: 'InsectFilterSelect',
  props: {
    value: {
      type: String,
      default: 'all',
    },
  },
  computed: {
    filterOptions() {
      const indoor = [];
      const outdoor = [];
      const other = [];

      Object.entries(flyingInsectTypeMap(this.$i18n.locale))
        .sort((a, b) => a[1].symbol - b[1].symbol)
        .forEach(([key, insect]) => {
          if (key === 'others') {
            return; // 「その他」はグループヘッダーのみ表示
          }
          const item = { text: insect.label, value: key, isGroup: false, indent: true };
          if (insect.route === 'indoor') {
            indoor.push(item);
          } else {
            outdoor.push(item);
          }
        });

      return [
        { text: this.$t('all'), value: 'all', isGroup: false, indent: false },
        { text: this.$t('indoor'), value: 'indoor', isGroup: true, indent: false },
        ...indoor,
        { text: this.$t('outdoor'), value: 'outdoor', isGroup: true, indent: false },
        ...outdoor,
        { text: this.$t('other'), value: 'other', isGroup: true, indent: false },
        ...other,
      ];
    },
  },
};
</script>

<style scoped>
.group-header {
  background-color: #f5f5f5;
}

.selection-text {
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
</style>
